/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import classnames from "gpages/utils/classnames"
import Clickable from "@src/components/clickable"

import logoImg from "@images/terminal_logo.png"
import micImg from "@images/terminal_mic.png"
import statusLightImg from "@images/terminal_statuslight_normal.png"
import statusLightActiveImg from "@images/terminal_statuslight_highlight.png"
import switchBtnImg from "@images/terminal_switch_normal.png"

import btnImg from "@images/terminal_key_normal.png"
import btnBackImg from "@images/terminal_key_back.png"
import btnNextImg from "@images/terminal_key_next.png"
import btnShareImg from "@images/terminal_key_share.png"
import infoImg from "@images/terminal_explanation.png"
import infoLogoImg from "@images/terminal_productinformation.png"
import { throttle } from "lodash"
import AnimateImage from "@src/components/animateImage"

import resource1Img from "@images/terminal_screen.png"
import resource2Img from "@images/terminal_groove.png"
import resource3Img from "@images/terminal_key_highlight.png"
import resource4Img from "@images/welcome_logo.svg"
import prepareImg from "@images/logo_background.png"
import { platformCheck, postAppMsg } from "gpages/utils/native_bridge"
import { useBrowserLayout } from "gpages/hooks/layout"

const resourceImages = [resource1Img, resource2Img, resource3Img, resource4Img]

const dispatchNavEvent = throttle(
  (next) => {
    const NEXT_EVENT = new CustomEvent("next")
    const BACK_EVENT = new CustomEvent("back")
    if (next) {
      window.dispatchEvent(NEXT_EVENT)
    } else {
      window.dispatchEvent(BACK_EVENT)
    }
  },
  501,
  {
    trailing: false,
    leading: true,
  }
)

const dispatchShareEvnet = () => {
  const SHARE_EVENT = new CustomEvent("share")
  window.dispatchEvent(SHARE_EVENT)
}

const Layout = ({ children, location }) => {
  const { isMobile, isWXBrowser, isNative } = useBrowserLayout()
  const [resourceLoaded, setResourceLoaded] = useState(false)

  // 让数据灯闪烁
  const light = () => {
    const lighter = document.querySelector(`.${styles.statusLight}`)
    if (!lighter) {
      return
    }

    requestAnimationFrame(() => {
      lighter.classList.remove(styles.light)
      requestAnimationFrame(() => {
        lighter.classList.add(styles.light)
      })
    })
  }

  // 加载资源，保证显示的时候基础字体和面板图片已经加载完毕
  useEffect(() => {
    // 加载后闪烁数据等
    if (resourceLoaded) {
      light()
      return
    }

    let loadedCount = 0
    let fontsLoaded = false
    const check = () => {
      if (loadedCount === resourceImages.length && fontsLoaded) {
        setResourceLoaded(true)
      }
    }

    // 图片加载
    const imgLoadEvent = () => {
      loadedCount += 1
      check()
    }
    for (const url of resourceImages) {
      const image = new Image()
      image.src = url
      image.style.visibility = "hidden"
      image.style.position = "absolute"
      image.style.top = "-300vh"
      image.onload = imgLoadEvent
      document.body.appendChild(image)
    }

    // 字体加载
    document.fonts.ready.then(function () {
      fontsLoaded = true
      check()
    })

    // 一段时间后强制显示
    setTimeout(() => {
      setResourceLoaded(true)
    }, 8000)
  }, [resourceLoaded])

  if (!resourceLoaded) {
    return (
      <div className={styles.mobileLayoutLoading}>
        <img src={prepareImg} alt="" />
      </div>
    )
  }

  return (
    <>
      <div
        className={classnames(styles.mobileLayoutLoading, styles.hideLoading)}
      >
        <img src={prepareImg} alt="" />
      </div>
      <AppContext.Provider
        value={{
          isMobile,
          isWXBrowser,
          light,
          dispatchNavEvent,
          dispatchShareEvnet,
          isNative,
        }}
      >
        <Seo />
        {/* <Nav location={location} /> */}
        <div className={styles.mobileLayoutFullscreen}>
          <div
            className={classnames(styles.mobileLayoutContainer, styles.isReady)}
          >
            <div className={styles.topPlaceholder} />
            <div className={styles.frontPanel}>
              <div className={styles.frontPanelBg}></div>
              <div className={styles.frontPanelBody}>
                <div className={styles.head}>
                  <div>
                    <img src={logoImg} className={styles.logo} alt="logo" />
                  </div>
                  <div className={styles.headRight}>
                    <img src={micImg} className={styles.mic} alt="mic" />
                    <AnimateImage
                      className={classnames(styles.statusLight)}
                      images={[statusLightImg, statusLightActiveImg]}
                    />
                    <Clickable
                      className={styles.closeBtn}
                      onClick={() => {
                        platformCheck(
                          () => {
                            postAppMsg("close")
                          },
                          () => {
                            window.location.href = "https://www.gcores.com"
                          }
                        )
                      }}
                    />
                  </div>
                </div>
                <div className={styles.screen}>{children}</div>
                <div className={styles.buttons}>
                  <Clickable
                    onClick={() => {
                      dispatchNavEvent(false)
                    }}
                  >
                    <img src={btnBackImg} alt="back" />
                  </Clickable>
                  <Clickable
                    onClick={() => {
                      dispatchNavEvent(true)
                    }}
                  >
                    <img src={btnNextImg} alt="next" />
                  </Clickable>
                  <Clickable
                    onClick={() => {
                      dispatchShareEvnet()
                    }}
                  >
                    <img src={btnShareImg} alt="share" />
                  </Clickable>
                </div>
              </div>
            </div>
            <div className={styles.backPanel}>
              <div>
                <img src={infoImg} alt="info" className={styles.infoText} />
              </div>
              <div>
                <img src={infoLogoImg} alt="info" className={styles.infoLogo} />
              </div>
            </div>
          </div>
        </div>
      </AppContext.Provider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
